module.exports = __webpack_public_path__ + "static/media/mal.e3c5e985.png";